import React from 'react';
// import './FourthSection.css';
import { Container } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router';
import logo from '../../Raya logo/Shira-Logo (1).png'
import cover from '../../Raya logo/Shira-Logo (1).png'
const Shira = () => {

    const navigate = useNavigate();
    const transferToPage = () => {
        // navigate('/Novus');
        window.open('https://www.instagram.com/shira.sweets/')
    }
    return (
        <div className='main-first-section newBrand'>
            <Container maxWidth="xl">
                <div className='content'>
                      <div>
                        <img src={cover} alt="mobile image not found" className='mainImage' />
                    </div> 
                    <div className='text-container novusLabPart' style={{ width: '100%' , }}>
                        {/* <img className='novuslab_image' src={logo} alt='novus-lab not found' /> */}
                        <h1 style={{ marginBottom: '0px' }} >Heritage & Craftsmanship</h1>
                        <h3 style={{ marginTop: '0px' }}>Where tradition meets a passion for detail.</h3>
                        <ArrowForwardIcon onClick={transferToPage} style={{ fontSize: '22px', border: '1px solid #000', borderRadius: '50%', padding: '4px', cursor: 'pointer' }} />
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default Shira;
